module.exports = __webpack_public_path__ + "h5/img/open.1365c561.gif";